import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Layout/TextPreview/styles.module.scss';
import { RenderPreviewText } from '../Layout/TextPreview';
import { usePracticeContext } from '../App/practiceContext';
import { getPrivacyConsent } from '../../models/practicePreferencesModel';

const Privacy = ({ preview = true, versionNumber }) => {
  const { publicProfile } = usePracticeContext();
  if (!publicProfile) { return null; }
  const consent = getPrivacyConsent(publicProfile, versionNumber);
  return (
    <div>
      <RenderPreviewText
        preview={preview}
        shortText={consent.privacyConsentShortText}
        mainText={consent.privacyConsentMainText}
        style={styles.legalAgreementText}
      />
    </div>
  );
};
Privacy.propTypes = {
  preview: PropTypes.bool,
  versionNumber: PropTypes.string,
};
Privacy.defaultProps = {
  preview: undefined,
  versionNumber: undefined,
};

export default Privacy;
